class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  cart_enableLoading() {
    console.log('enabling loader')
    const cart_drawer = document.getElementById('mini-cart');
    if (cart_drawer) cart_drawer.classList.add('cart__items--disableddd');
  }

  cart_disableLoading() {
    const cart_drawer = document.getElementById('mini-cart');
    if (cart_drawer) cart_drawer.classList.remove('cart__items--disableddd');
  }


  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  min_gift_product() {
    if (!window.cartStrings.variant || !window.cartStrings.free_product_collections) return;

    const freeProductId = window.cartStrings.variant.trim();
    const min_gift_val = parseInt(window.cartStrings.amount.trim()) * 100;

    fetch(`${window.routes.cart_url}.js`)
      .then(response => response.json())
      .then(data => {
        const cartTotal = data.total_price;
        let addGift = false;

        // Check if any item in the cart is in the eligible collections for the free product
        for (let item of data.items) {
          const collections = item.product.collections || [];
          const eligibleCollections = JSON.parse(window.cartStrings.free_product_collections);

          if (collections.some(collection => eligibleCollections.includes(collection)) && !item.properties?._min_gift) {
            addGift = true;
            break;
          }
        }

        if (cartTotal > min_gift_val && addGift) {
          fetch(`${window.routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: freeProductId,
              quantity: 1,
              properties: { _min_gift: "true" }
            }),
          })
            .then(response => response.text())
            .then(html => {
              fetch(this.dataset.url)
                .then(response => response.text())
                .then(html => {
                  document.getElementById("mini-cart").innerHTML =
                    this.getSectionInnerHTML(html, ".shopify-section");
                })
                .catch(e => {
                  console.error(e);
                });
            });
        } else if (cartTotal < min_gift_val && addGift) {

          const freeProductItem = data.items.find(item => item.id === freeProductId && item.properties?._min_gift === "true");
          if (freeProductItem) {
            fetch(window.routes.cart_change_url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: freeProductItem.id,
                quantity: 0
              })
            })
            .then(response => response.text())
            .then(html => {
              fetch(this.dataset.url)
                .then(response => response.text())
                .then(html => {
                  document.getElementById("mini-cart").innerHTML =
                    this.getSectionInnerHTML(html, ".shopify-section");
                });
            });
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
}

customElements.define('mini-cart', MiniCart);
